import EN from '../../../../locales/en.default.json';
import FR from '../../../../locales/fr.json';

const language = window.multilingual_settings?.currentLangIso;
const languageStore = language === 'fr' ? FR : EN;

const getByPath = (obj, path, separator=".") => {
  var properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev, curr) => prev && prev[curr], obj);
};

export const themeI18n = (path, variables) => {
  let string = getByPath(languageStore, path);

  if (string === undefined) {
    return `Translation missing: ${language}.${path}`;
  }

  if (variables) {
    Object.keys(variables).forEach((key) => {
      string = string.replace(`{{ ${key} }}`, variables[key]);
    });
  }

  return string;
}
